import HttpKit from '@/utils/http-kit'
import Cookies from 'js-cookie'

/**
 * https://api.easyjcx.com/api/swagger-ui.html#//loginCli
 */
export default {
  /**
   * 扫描件信息完善
   * /loginCli/completeCpInfo
   * @param afSalePromise 产品质量及售后服务承诺书
   * @param businessLicense 营业执照扫描件
   * @param idCardB 法定代表人身份证扫描件背面
   * @param idCardF 法定代表人身份证扫描件正面
   * @param organizationCode 税务登记证书扫描件
   * @param taxRegistration 组织机构代码证书URL
   */
  completeCpInfo (cpCompleteDto, headers) {
    return HttpKit.post('/api/loginCli/completeCpInfo', cpCompleteDto, {headers}).then(
      res => res.data
    )
  },
  /**
   * /loginCli/isUserExist
   * 检查用户是否存在
   * @param cpRegistDto
   */
  isUserExist (cpRegistDto) {
    return HttpKit.post('/api/loginCli/isUserExist', cpRegistDto).then(
      res => res.data
    )
  },
  /**
   * /loginCli/isCpParamExist
   * 判断企业注册时参数是否存在，传几个验几个,&&关系,注意：企业邮箱、企业名称、组织机构代码，营业执照注册号/ 统一社会信用代码，每条都不可重复，法定代表人证件号每个省市下也不可重复
   * @param cpRegistDto
   */
  isCpParamExist (cpRegistDto) {
    return HttpKit.post('/api/loginCli/isCpParamExist', cpRegistDto, {showMessage: false}).then(
      res => res
    )
  },
  /**
   *
   /loginCli/getTianyanchaInfo
   * 企业名称通过天眼查来自动填入信息
   * @param cpRegistDto
   */
  getTianyanchaInfo (cpRegistDto) {
    return HttpKit.post('/api/loginCli/getTianyanchaInfo', cpRegistDto, {showMessage: false}).then(
      res => res
    )
  },

  /**
   * /loginCli/getCollege
   * 获取高校信息
   * @param queryKeyword
   * @returns {Promise<T | never>}
   */
  getCollege (queryKeyword) {
    return HttpKit.post('/api/loginCli/getCollege', {
      queryKeyword: queryKeyword
    }).then(
      res => res.data
    )
  },
  /**
   * /loginCli/getCollege
   * 获取审核高校信息
   * @param queryKeyword
   * @returns {Promise<T | never>}
   */
  getAuditCollege (queryKeyword) {
    return HttpKit.post('/api/loginCli/getAuditCollege', {
      queryKeyword: queryKeyword
    }).then(
      res => res.data
    )
  },
  /**
   * /loginCli/cpRegist
   * 供应商注册
   * @param cpRegistDto
   */
  cpRegist (cpRegistDto) {
    return HttpKit.post('/api/loginCli/cpRegistOne', cpRegistDto).then(
      res => res.data
    )
  },
  /**
   * /loginCli/cpRegist
   * 供应商注册二
   * @param cpRegistDto
   */
  cpRegistTwo (cpRegistDto) {
    return HttpKit.post('/api/loginCli/cpRegistTwo', cpRegistDto,{
      headers: {
        CpAuthorization: Cookies.get('CpAuthorization')  //token
      }
    }).then(
      res => res.data
    )
  },
  /**
   * loginCli/cpRegist/agreement
   * 供应商注册协议
   * @returns {Promise<T | never>}
   */
  agreement () {
    return HttpKit.post('/api/loginCli/cpRegist/agreement', {}).then(
      res => res.data
    )
  },
  /**
   * loginCli/privacy
   * 隐私政策
   * @returns {Promise<T | never>}
   */
  privacy () {
    return HttpKit.post('/api/loginCli/privacy', {}).then(
      res => res.data
    )
  },
  /**
   * loginCli/getUserInfo
   * 登陆后完善信息
   * @returns {}
   */
  getUserInfo (authCodeToken) {
    return HttpKit.post('/api/loginCli/getUserInfo', {},{
      headers: {
        "CpAuthorization":authCodeToken  //token
      }
    }).then(
      res =>res
    )
  },
  /**
   * /loginCli/deletedScrapCompany
   * 供应商注册第二步删除多余数据
   * @returns {}
   */

  deletedScrapCompany (authCodeToken) {
    return HttpKit.post('/api/loginCli/deletedScrapCompany',{}, {
      headers: {
        CpAuthorization: authCodeToken
      }
    }).then(
      res => res.data
    )
  },
  //
  //
  // areaInfoList (queryKeyword) {
  //   return HttpKit.post('/api/loginCli/areaInfoList', {
  //     queryKeyword: queryKeyword
  //   }).then(
  //     res => res.data
  //   )
  // },
}



// WEBPACK FOOTER //
// ./src/api/supplier/register.js